import React from 'react';
import PropTypes from 'prop-types';
import { CustomButton } from '@/components';
import './ToggleSwitch.scss';

const ToggleSwitch = ({ checked, onChange, disabled }) => {
   return (
      <CustomButton
         as="div"
         role="switch"
         aria-checked={checked}
         className={`toggleSwitchContainer ct-relative ct-inlineFlex ct-aiCenter ct-cursor ${checked ? 'is-checked' : ''}`}
         onClick={e => {
            e.stopPropagation();
            if (!disabled) onChange(e);
         }}
         disabled={disabled}
      >
         <span className="slider ct-relative"></span>
      </CustomButton>
   );
};

ToggleSwitch.propTypes = {
   checked: PropTypes.bool.isRequired,
   onChange: PropTypes.func.isRequired,
   disabled: PropTypes.bool,
};

export default ToggleSwitch;
